export const getModalTitle = ({ modal }) => modal.title;
export const getModalContent = ({ modal }) => modal.content;
export const getModalIsOpen = ({ modal }) => !!modal.content;
export const getModalClassName = ({ modal }) => modal.className;
export const getModalConfig = ({ modal }) => modal.config;
export const getModalCloseButton = ({ modal }) => modal.closeButton;
export const getModalOnClose = ({ modal }) => modal.onClose;
